import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '../layout/index'
import HomeView from '../views/home/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/home',
    component: layout,
    children: [
      {
        path: 'home',
        name: 'home',
        component: HomeView
      },
      {
        path: 'productAbout',
        name: 'productAbout',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/about/index.vue')
      },
      {
        path: 'productAbout1',
        name: 'productAbout1',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/emptyPage/index.vue')
      },
      {
        path: 'productAbout2',
        name: 'productAbout2',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/emptyPage/index.vue')
      },
      {
        path: 'productAbout3',
        name: 'productAbout3',
        component: () =>
          import(/* webpackChunkName: "about" */ '../views/emptyPage/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
